import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

interface IRequest {
  complaintId: number;
  attachmentId: number;
}

const deleteReturnComplaintAttachment = (data: IRequest): Promise<ICommandResponseSuccess> =>
  axios.delete(`/panel/return-complain/requests/${data.complaintId}/attachments/${data.attachmentId}`);

export const useDeleteReturnComplaintAttachment = (
  options?: UseMutationOptions<ICommandResponseSuccess, IError, IRequest>
) => useMutation((data: IRequest) => deleteReturnComplaintAttachment(data), options);
